import type { CNCOverlayStep } from '@interfaces/checkout'

export const CNC_OVERLAY_STEP: { [K in CNCOverlayStep]: K } = {
  addressSelection: 'addressSelection',
  storeSelection: 'storeSelection',
  review: 'review',
}
